/** Curvas de spawn do Baseline A.1 — funções puras de t (minutos). */
import type { Rng } from './rng.ts';
import { ENEMY_FAMILIES } from '../data/index.ts';

/** inimigos por segundo: base 1,6 + 0,42·t (calibrado v0.1) × densidade co-op × Modo Coragem */
export function spawnRate(tMin: number, playerCount = 1, modoCoragem = false): number {
  const base = 1.6 + 0.42 * tMin;
  const coop = 1 + 0.4 * (playerCount - 1); // A.5: densidade ×(1+0,40·(n−1))
  const coragem = modoCoragem ? 0.8 : 1; // ACC-6: −20% densidade
  return base * coop * coragem;
}

/** teto de vivos: rampa 0→120 no 1º min, 120→600 até o min 10 (Baseline A.1) */
export function aliveCap(tMin: number): number {
  if (tMin <= 0) return 20;
  if (tMin < 1) return Math.max(20, Math.round(120 * tMin));
  if (tMin >= 10) return 600;
  return Math.round(120 + ((600 - 120) * (tMin - 1)) / 9);
}

/** HP base do Soneco: 10·(1+0,18·t), × fator da família, × escala co-op e capítulo */
export function enemyHp(tMin: number, hpFator: number, playerCount: number, chapter: number): number {
  const coop = 1 + 0.55 * (playerCount - 1); // A.5
  const cap = 1 + 0.12 * (chapter - 1); // A.1
  return Math.round(10 * (1 + 0.18 * tMin) * hpFator * coop * cap * 10) / 10;
}

/** escolhe família por peso (50/30/20 no cap. 1) — determinístico via rng */
export function pickFamily(rng: Rng): (typeof ENEMY_FAMILIES)[number] {
  const total = ENEMY_FAMILIES.reduce((s, f) => s + f.peso, 0);
  let roll = rng.int(1, total);
  for (const f of ENEMY_FAMILIES) {
    roll -= f.peso;
    if (roll <= 0) return f;
  }
  return ENEMY_FAMILIES[0] as (typeof ENEMY_FAMILIES)[number];
}
